import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealTierItemEntity } from '../../domain/entities/MealTierItemEntity'
import type { MealTierListedAdminDto } from '@/backend/market'

export class MealTierItemModel extends MealTierItemEntity {
  constructor(dataDto: MealTierListedAdminDto) {
    super()
    mapEntityProperties<MealTierItemEntity>(this, dataDto)
  }
}
